export const DISCOUNT_TABLE_COLUMNS = Object.freeze([
  {
    header: "№пп",
    accessorKey: "number",
    size: 30,
  },
  {
    header: "Factory",
    accessorKey: "factory",
    size: 170,
  },
  {
    header: "Price",
    accessorKey: "sum",
    // size: 100,
  },
  {
    header: "postDiscountSum",
    accessorKey: "resultSum",
    // size: 100,
  },
  {
    header: "Discount sum",
    accessorKey: "discountSum",
    // size: 100,
  },
  {
    header: "%% discount",
    accessorKey: "discountValue",
    // size: 100,
  },
]);

export const SERVICE_TABLE_COLUMNS = Object.freeze([
  {
    header: "№пп",
    accessorKey: "number",
    size: 20,
    maxSize: 20,
  },
  {
    header: "Service",
    accessorKey: "service",
    size: 100,
  },
  {
    header: "Sum",
    accessorKey: "serviceCost",
    size: 70,
  },
  // {
  //   header: "Discount",
  //   accessorKey: "discount",
  //   // size: 100,
  // },
  // {
  //   header: "Discount sum",
  //   accessorKey: "discountSum",
  //   // size: 100,
  // },
  // {
  //   header: "%% discount",
  //   accessorKey: "discountProc",
  //   // size: 100,
  // },
]);

export const MAIN_SERVICE_AND_DISCOUNT_TABLE_COLUMNS = Object.freeze([
  {
    header: "№пп",
    accessorKey: "number",
    // size: 50,
  },
  {
    header: "Discount application articles",
    accessorKey: "title",
    size: 500,
  },
  {
    header: "Price",
    // header: "Spec. disc. amount",
    accessorKey: "sum",
  },
  {
    header: "Discount sum",
    // header: "Indiv. disc. amount",
    accessorKey: "discountSum",
    // size: 100,
  },
  {
    header: "%% discount",
    // header: "Amount with indiv. disc.",
    accessorKey: "discountValue",
    // size: 100,
  },
  {
    header: "Indiv. disc. amount",
    accessorKey: "topDiscountSum",
    // size: 100,
  },
  // {
  //   header: "Amount with indiv. disc.",
  //   accessorKey: "topDiscountValue",
  //   // size: 100,
  // },
  {
    header: "Payment amount",
    accessorKey: "resultSum",
    // size: 100,
  },
]);
